import { LicenseIcon } from "@/component/common/icons/LicenseIcon.tsx";
import { LICENSE_REGISTRATION_ENUM } from "@/constant/constants.ts";
import { Flex } from "antd";
import { useTranslation } from "react-i18next";

const LicenseRegistrationStatusTag = ({
  status,
  hasIcon = false,
}: {
  status?: number | null;
  hasIcon?: boolean;
}) => {
  const { t } = useTranslation();

  let color = "#fafafa";
  if (status === LICENSE_REGISTRATION_ENUM.ACTIVE) {
    color = "#FF0FE7";
  } else if (status === LICENSE_REGISTRATION_ENUM.ALMOST_EXPIRED) {
    color = "#4A58EC";
  } else if (status === LICENSE_REGISTRATION_ENUM.EXPIRED) {
    color = "#A1A9B1";
  } else if (status === LICENSE_REGISTRATION_ENUM.OVERDUE_RELEASE) {
    color = "#172635";
  }
  const LICENSE_REGISTRATION_MAP: Map<number, string> = new Map([
    [LICENSE_REGISTRATION_ENUM.ACTIVE, t("field.active")],
    [LICENSE_REGISTRATION_ENUM.ACTIVE, t("field.active")],
    [LICENSE_REGISTRATION_ENUM.ALMOST_EXPIRED, t("field.expiringSoon")],
    [LICENSE_REGISTRATION_ENUM.EXPIRED, t("field.expired")],
    [LICENSE_REGISTRATION_ENUM.OVERDUE_RELEASE, t("field.overdueRelease")],
  ]);
  return (
    <>
      {status ? (
        <Flex key={status} className={"whitespace-nowrap"} align={"center"}>
          {!hasIcon ? (
            <span style={{ color: color }}>•</span>
          ) : (
            <LicenseIcon fillColor={color} />
          )}
          &nbsp;{LICENSE_REGISTRATION_MAP.get(status)}
        </Flex>
      ) : (
        <span>-</span>
      )}
    </>
  );
};

export default LicenseRegistrationStatusTag;
